import api from '../../utils/api'

const API_BASE_URL = "/admin/ADPTnt";

const ADPTntService = {
    async findAll(): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-all`);
        return response.data;
    },

    async getItemById(facilityCode: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-one/${facilityCode}`);
        return response.data;
    },

    async create(item: any): Promise<any> {
        const response = await api.post(`${API_BASE_URL}/create`, item);
        return response.data;
    },

    async update(facilityCode: string, item: any): Promise<any> {
        const response = await api.put(`${API_BASE_URL}/update/${facilityCode}`, item);
        return response.data;
    },

    async delete(facilityCode: string): Promise<any> {
        const response = await api.delete(`${API_BASE_URL}/delete/${facilityCode}`);
        return response.data;
    },

    async getItemsExcludeFacilityCode(facilityCode: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-all-exclude/${facilityCode}`);
        return response.data;
    },

    async getItemsExcludeInFacilityCodes(codesToExclude: any): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-all-excludes/${codesToExclude}`);
        return response.data;
    },
    
};

export default ADPTntService;